<div class="modal fade" id="kt_modal_title_manager_add_edit" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-650px">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">{{ isEditMode ? 'Update Title Manager' : 'Add Title Manager' }}</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <form [formGroup]="titleManagerForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="modal-body p-5">
          <div class="row">
            <!-- Link File Name -->
            <div class="col-md-12 mb-5">
              <label class="form-label required">Link File Name</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="link_file_name"
                placeholder="Enter link file name"
                [class.is-invalid]="link_file_name?.invalid && link_file_name?.touched"
              />
              <div *ngIf="link_file_name?.invalid && link_file_name?.touched" class="invalid-feedback">
                <div *ngIf="link_file_name?.errors?.['required']">Link file name is required</div>
              </div>
            </div>

            <!-- Title -->
            <div class="col-md-12 mb-5">
              <label class="form-label required">Title</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="title"
                placeholder="Enter title"
                [class.is-invalid]="title?.invalid && title?.touched"
              />
              <div *ngIf="title?.invalid && title?.touched" class="invalid-feedback">
                <div *ngIf="title?.errors?.['required']">Title is required</div>
              </div>
            </div>

            <!-- Description -->
            <div class="col-md-12 mb-5">
              <label class="form-label">Description</label>
              <textarea
                class="form-control form-control-solid"
                formControlName="description"
                placeholder="Enter description"
                rows="3"
              ></textarea>
            </div>

            <!-- Keywords -->
            <div class="col-md-12 mb-5">
              <label class="form-label">Keywords</label>
              <textarea
                class="form-control form-control-solid"
                formControlName="keywords"
                placeholder="Enter keywords"
                rows="3"
              ></textarea>
            </div>

            <!-- Show -->
            <div class="col-md-12 mb-5">
              <label class="form-label">Show</label>
              <div class="d-flex gap-5">
                <div class="form-check form-check-custom form-check-solid">
                  <input
                    class="form-check-input"
                    type="radio"
                    formControlName="show"
                    value="show"
                    id="show_yes"
                  />
                  <label class="form-check-label" for="show_yes">
                    Show
                  </label>
                </div>
                <div class="form-check form-check-custom form-check-solid">
                  <input
                    class="form-check-input"
                    type="radio"
                    formControlName="show"
                    value="no_show"
                    id="show_no"
                  />
                  <label class="form-check-label" for="show_no">
                    No Show
                  </label>
                </div>
              </div>
            </div>

            <!-- Set as Default -->
            <div class="col-md-12 mb-5">
              <div class="form-check form-check-custom form-check-solid">
                <input
                  class="form-check-input"
                  type="checkbox"
                  formControlName="set_as_default"
                  id="set_as_default"
                />
                <label class="form-check-label" for="set_as_default">
                  Set as Default
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer p-3">
          <button
            type="button"
            class="btn btn-light"
            data-bs-dismiss="modal"
            [disabled]="isLoading">
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="isLoading">
            <span *ngIf="!isLoading">{{ isEditMode ? 'Update' : 'Add' }}</span>
            <span *ngIf="isLoading">
              <span class="spinner-border spinner-border-sm align-middle me-2"></span>
              Please wait...
            </span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
